import { Component, Input } from '@angular/core';

import { CaEvaluationComponent } from '../../ca-evaluation.component';

@Component({
    selector: 'cmps-ca-analysis-dialog-toolbar',
    templateUrl: './toolbar.component.html',
})
export class ToolbarComponent {
    @Input() evalRef: CaEvaluationComponent;
}
